export default {
  signal: 'Sygnał',
  unit: 'Jednostka',
  min: 'Min',
  max: 'Max',
  average: 'ȳ',
  standardDeviation: 'σ',
  cursor: 'kursor',
};
